import { useState, useEffect, useContext } from 'react';
import { $getSelection, $isRangeSelection } from 'lexical';
import { $isLinkNode } from '@lexical/link';
import { useRichTextEditor, RichTextEditorCtx } from '../RichTextEditorProvider';
import { IconButton, Tooltip } from '@sweep-io/sweep-design';
import { Link } from '@sweep-io/sweep-design/dist/icons';
import { LinkPopup } from '../LinkPopup';

export const LinkButton = () => {
  const { setUrlEditorOpen } = useContext(RichTextEditorCtx);
  const { editor } = useRichTextEditor();
  const [isLink, setIsLink] = useState(false);
  const [linkUrl, setLinkUrl] = useState('');
  const [popupPosition, setPopupPosition] = useState<{ top: number; left: number } | null>(null);

  const _setPopupPosition = (position: { top: number; left: number } | null) => {
    setPopupPosition(position);
    setUrlEditorOpen(position !== null);
  };

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }: any) => {
      editorState.read(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          const anchorNode = selection.anchor.getNode();
          const parent = anchorNode.getParent();

          if ($isLinkNode(parent)) {
            setIsLink(true);
            setLinkUrl(parent.getURL());
          } else if ($isLinkNode(anchorNode)) {
            setIsLink(true);
            setLinkUrl(anchorNode.getURL());
          } else {
            setIsLink(false);
            setLinkUrl('');
          }
        }
      });
    });
  }, [editor]);

  const getSelectionPosition = () => {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return null;

    const range = selection.getRangeAt(0);
    const rect = range.getBoundingClientRect();

    if (rect.width === 0 && rect.height === 0) {
      // Cursor position (collapsed selection)
      return {
        top: rect.top,
        left: rect.left,
      };
    } else {
      // Text selection - position at the center of the selection
      return {
        top: rect.top,
        left: rect.left + rect.width / 2,
      };
    }
  };

  const handleLinkButtonClick = () => {
    const position = getSelectionPosition();
    if (position) {
      _setPopupPosition(position);
    }
  };

  return (
    <>
      <Tooltip title="Link (Ctrl+K)">
        <IconButton variant="squared" size="small" onClick={handleLinkButtonClick} pressed={isLink}>
          <Link />
        </IconButton>
      </Tooltip>
      <LinkPopup
        position={popupPosition}
        onClose={() => _setPopupPosition(null)}
        initialUrl={linkUrl}
      />
    </>
  );
};
